import { useState, useEffect, useCallback } from "react";
import { api } from "../context/AuthContext";
import FloatingViki from "../components/FloatingViki";
import VikiLogin from "./VikiLogin";
import "./VikiLogin.css";

export default function VikiStandalonePage() {
  const [authState, setAuthState] = useState("checking"); // checking | authenticated | anonymous

  const checkAccess = useCallback(async () => {
    try {
      const { data } = await api.get("/viki/access-check");
      setAuthState(data?.authorized ? "authenticated" : "anonymous");
    } catch {
      // Nessuna sessione valida o errore di rete: in entrambi i casi login,
      // senza distinguere i due casi per non rivelare se un account esiste.
      setAuthState("anonymous");
    }
  }, []);

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  // Identità PWA dedicata SOLO su questa rotta: manifest, titolo e icona
  // di VIKI al posto di quelli del portale, ripristinati uscendo.
  useEffect(() => {
    document.title = "V.I.K.I.";
    const font = document.createElement("link");
    font.rel = "stylesheet";
    font.href = "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap";
    document.head.appendChild(font);
    const manifest = document.querySelector('link[rel="manifest"]');
    const prevManifest = manifest?.getAttribute("href");
    manifest?.setAttribute("href", "/viki-manifest.json");
    const touchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    const prevIcon = touchIcon?.getAttribute("href");
    touchIcon?.setAttribute("href", "/viki-icons/icon-192.png");
    const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const prevTitle = appleTitle?.getAttribute("content");
    appleTitle?.setAttribute("content", "V.I.K.I.");
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/viki-sw.js", { scope: "/viki-app" }).catch(() => {
        // Registrazione fallita: la pagina funziona comunque nel browser,
        // semplicemente senza prompt di installazione.
      });
    }
    return () => {
      document.title = "AreaPAQ";
      font.remove();
      if (prevManifest) manifest?.setAttribute("href", prevManifest);
      if (prevIcon) touchIcon?.setAttribute("href", prevIcon);
      if (prevTitle) appleTitle?.setAttribute("content", prevTitle);
    };
  }, []);

  if (authState === "checking") {
    return (
      <div className="viki-standalone-loading" data-testid="viki-pwa-loading">
        <img src="/viki/viki-idle.png" alt="V.I.K.I." />
        <p>Verifica dell'accesso in corso…</p>
      </div>
    );
  }

  if (authState === "anonymous") {
    return <VikiLogin onLoginSuccess={checkAccess} />;
  }

  return (
    <div className="viki-standalone-app" data-testid="viki-pwa-app">
      <FloatingViki standalone />
    </div>
  );
}
